export const cartDeclarations = {
    drawing: {
        version: 1,
        text: 'I confirm that I have checked all my selections and dimensions shown on every drawing in this Cart and that they are correct. I understand that, if ordered, my doors will be custom-made to these exact details.',
    },
    terms: {
        version: 1,
        text: 'I agree to the Terms and Conditions.',
    },
    privacy: {
        version: 1,
        text: 'I have read the Privacy Policy.',
    },
};
//# sourceMappingURL=cart-declarations.js.map